/**
 * Whether a call made through `Services/ApiClient` succeeded. The client does not throw on a failed
 * call - it reports the error (`data.error`, the HTTP status of the failure or none at all).
 */
export const isApiSuccess = (response: {
	status?: number;
	data?: unknown;
}): boolean =>
	response.status !== undefined &&
	response.status >= 200 &&
	response.status < 300 &&
	!(response.data as { error?: boolean } | undefined)?.error;
